import * as React from "react";
import Button from "components/bootstrap/Button";
import SharingDisabledPopover from "components/permissions/SharingDisabledPopover";
import HasOwnership from "components/common/HasOwnership";
import Icon from "components/common/Icon";
const ShareButton = ({
  bsStyle = "default",
  bsSize = void 0,
  entityId,
  entityType,
  onClick,
  disabledInfo = void 0,
  title = void 0
}) => /* @__PURE__ */ React.createElement(HasOwnership, { id: entityId, type: entityType }, ({ disabled: hasMissingPermissions }) => /* @__PURE__ */ React.createElement(
  Button,
  {
    bsStyle,
    bsSize,
    onClick,
    disabled: !!disabledInfo || hasMissingPermissions,
    title: "Share"
  },
  /* @__PURE__ */ React.createElement(Icon, { name: "person_add" }),
  " ",
  title != null ? title : "Share",
  " ",
  (!!disabledInfo || hasMissingPermissions) && /* @__PURE__ */ React.createElement(SharingDisabledPopover, { type: entityType, description: disabledInfo })
));
export default ShareButton;
